import state from "./state";

const getters = {
  username() {
    return localStorage.getItem("username");
  },
  currentLang() {
    return this.$store.state.currentLang;
  },
};
export default getters;
